import React from 'react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import theme from './theme/theme'; // Custom MUI theme
import { store } from './store/rootStore'; // Redux store
import App from './App'; // Main App component
import './index.css'; // Global styles
import reportWebVitals from './reportWebVitals'; // Performance measurement
import { AuthProvider } from '../src/pages/login/AuthContext';
const rootElement = document.getElementById('root') as HTMLElement;
const root = createRoot(rootElement);

root.render(
  <StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          <App />
        </AuthProvider>
      </ThemeProvider>
    </Provider>
  </StrictMode>
);

// If you want to start measuring performance in your app
// Use this to track performance or send to an analytics endpoint
reportWebVitals();
